<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div edsGrid>
      <div edsRow>
        <div edsCol>
          <eds-section-header
            [title]="'products.us-tax-information' | translate"
            [level]="3"
            edsSpacing="md"
          ></eds-section-header>
          <eds-section-header
            [title]="federalTaxIdTitle"
            [subTitle]="'products.us-tax-year-message' | translate"
            [level]="6"
            edsSpacing="md"
          ></eds-section-header>
          <div>
            {{ "products.us-tax-distributions-description" | translate }}
          </div>
        </div>
      </div>

      <div edsSubGrid="layout-6" edsSpacing="md">
        <div>
          <div edsSpacing="md"></div>
          <eds-section-header
            [title]="'products.us-tax-distributions-per-share' | translate"
            [level]="5"
            edsSpacing="sm"
          ></eds-section-header>
          <div *ngIf="distributions?.length > 0 && !isSiteIntl">
            <button
              edsbutton="secondary"
              class="ft__btn--secondary ft__btn"
              (click)="downloadTaxInfoExcel()"
            >
              {{ "products.tax-info-download" | translate }}
              ({{ "products.xls-file-extension" | translate }})
              <eds-icon
                type="download"
                size="small"
                edspadding=""
                edsPaddingLeft="xs"
              ></eds-icon>
            </button>
          </div>
        </div>
        <div>
          <div edsSpacing="md"></div>
          <eds-dropdown
            ariaLabel="Dropdown"
            [dropdownId]="getDropdownId"
            name="tax-year-select"
            label="{{ 'products.year' | translate }}"
            [items]="yearOptions"
            [titleText]="getTitleText(yearOptionSelected)"
            [selectedText]="yearOptionSelected"
            (dropdownChange)="onTaxYearChanged($event)"
          ></eds-dropdown>
        </div>
      </div>

      <div edsRow>
        <div edsCol edsSpacing="lg">
          <ft-us-tax-distributions
            *ngIf="hasDataForCurrentYear && distributions?.length > 0"
            [distributions]="distributions"
          ></ft-us-tax-distributions>
          <span
            *ngIf="!hasDataForCurrentYear"
            class="noTaxYet"
            [innerHtml]="noDataMessage"
          ></span>
        </div>
      </div>

      <div *ngIf="additional?.length || states?.length || pdf">
        <div edsGrid>
          <div edsRow>
            <eds-panel
              *ngIf="additional?.length"
              edsCol
              [columnNumbers]="{ s: '4', m: '6', l: '4' }"
              class="list-details"
              [hasBorders]="true"
              [hasPadding]="true"
              edsSpacing
              edsSpacingBottom="sm"
              theme="white"
            >
              <eds-section-header
                [level]="6"
                theme="primary"
                size="h6"
                edsSpacing="md"
                [analyticsName]="
                  'products.us-tax-additional-section-title' | translate
                "
                [title]="'products.us-tax-additional-section-title' | translate"
                [tooltip]="tooltips['products.us-tax-additional-section-title']"
              >
              </eds-section-header>

              <eds-info-item *ngFor="let item of additional" [info]="item">
              </eds-info-item>
            </eds-panel>

            <eds-panel
              *ngIf="states?.length"
              edsCol
              [columnNumbers]="statesColumns"
              class="list-details"
              [hasBorders]="true"
              [hasPadding]="true"
              theme="white"
            >
              <eds-section-header
                [level]="6"
                theme="primary"
                size="h6"
                edsSpacing="md"
                [analyticsName]="
                  'products.us-tax-states-section-title' | translate
                "
                [title]="'products.us-tax-states-section-title' | translate"
                [tooltip]="tooltips['products.us-tax-states-section-title']"
              >
              </eds-section-header>
              <div edsCssCols [maxCols]="stateCols" colGap="xxxl">
                <eds-info-item *ngFor="let state of states" [info]="state">
                </eds-info-item>
              </div>
            </eds-panel>
          </div>
        </div>

        <eds-thumbnail
          [hasBorders]="true"
          [hasShadows]="true"
          [headingLevel]="2"
          docTypeSrc="/assets/images/brand/PDF_file_icon.svg"
          [title]="lmPdfMessage"
          [href]="pdf"
          [buttonText]="
            'products.additional-tax-download-pdf' | translate: brConfig.fundId
          "
          [isNewWindow]="true"
          *ngIf="pdf"
        >
        </eds-thumbnail>
        <eds-proximal
          placement="UsTaxAdditionalTaxInformationBottom"
        ></eds-proximal>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>US Tax</h5>
</ng-template>
